import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function PromoBanner({ image, title, subtitle, buttonColor, textColor, onClick }) {
  const navigate = useNavigate();

  const handleShopNow = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/products');
      // Scroll to top after navigation
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  return (
    <motion.article
      className="overflow-hidden relative flex-1 rounded-3xl h-[422px] max-md:h-[380px] max-sm:h-[320px] min-h-[350px]"
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.3 }}
      style={{
        height: 'clamp(250px, 25vw, 422px)'
      }}
    >
      <img
        src={image}
        alt=""
        className="object-cover size-full"
      />
      <div
        className="absolute left-11 w-[345px] max-md:left-6 max-md:w-[calc(100%_-_48px)] max-sm:left-4 max-sm:w-[calc(100%_-_32px)]"
        style={{
          top: 'clamp(60px, 25%, 106px)'
        }}
      >
        <p className={`mb-5 text-xl font-bold leading-8 ${textColor} uppercase tracking-[2.4px] max-md:text-lg max-md:leading-6 max-md:mb-3 max-sm:text-base max-sm:leading-5 max-sm:tracking-[1.5px] max-sm:mb-2`}
           style={{
             fontSize: 'clamp(0.75rem, 4vw, 1.25rem)',
             lineHeight: 'clamp(1rem, 5vw, 2rem)',
             letterSpacing: 'clamp(1px, 2vw, 2.4px)',
             marginBottom: 'clamp(8px, 2vw, 20px)'
           }}>
          {title}
        </p>
        <h3 className={`mb-6 text-4xl font-bold leading-10 ${textColor} max-md:text-3xl max-md:leading-8 max-md:mb-4 max-sm:text-2xl max-sm:leading-7 max-sm:mb-3`}
            style={{
              fontSize: 'clamp(1.25rem, 6vw, 2.25rem)',
              lineHeight: 'clamp(1.5rem, 7vw, 2.5rem)',
              marginBottom: 'clamp(12px, 3vw, 24px)'
            }}>
          {subtitle}
        </h3>
        <motion.button
          onClick={handleShopNow}
          className={`px-6 py-2.5 text-base font-bold text-white uppercase ${buttonColor} transition-all cursor-pointer duration-[0.3s] ease-[ease] rounded-[90px] shadow-[0_8px_25px_rgba(0,0,0,0.25)] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 max-sm:px-4 max-sm:py-2 max-sm:text-sm`}
          style={{
            fontSize: 'clamp(0.75rem, 3vw, 1rem)',
            height: 'clamp(36px, 8vw, 54px)',
            padding: 'clamp(8px, 2vw, 10px) clamp(16px, 4vw, 24px)'
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Shop now for top rated toys"
        >
          Shop Now
        </motion.button>
      </div>
    </motion.article>
  );
}

export default PromoBanner;
